module.exports = __webpack_public_path__ + "img/serifnew_box08.868482c3.jpg";